export const AmplitudeEvent = {
	DISPLAY_REVIEW: 'wixct_display_review',
	POST_REVIEW: 'wixct_post_review',
	TEMPLATE_SELECTED: 'wixct_templateselected',
	TIMER_CREATED: 'wixct_timercreated',
} as const;
